import constants from '../../constants'

const initialState = {
  object: {},
  error: null,
  isLoading: false,
  singlePageData: { activities: [], activitiesGrouped: [] },
}

const SinglePageReducer = (state = initialState, { type, payload }) => {

  switch (type) {

    case 'SET_SINGLE_PAGE_DATA':
      return {
        ...state,
        isLoading: false,
        singlePageData: payload,
        object: constants.getObjectSchema(payload['objectType']),
      }

    case 'CLEAR_SINGLE_PAGE_DATA':
      return {
        ...state,
        object: {},
        singlePageData: { activities: [], activitiesGrouped: [] },
      }

    case 'SET_ACTIVITY':
      return {
        ...state,
        singlePageData: { ...state['singlePageData'], activities: payload['activities'] || [], activitiesGrouped: payload['activitiesGrouped'] || [] },
      }

    case 'SET_DELETE_ACTIVITY':
      return {
        ...state,
        singlePageData: { 
          ...state['singlePageData'], 
          activities: state['singlePageData']['activities'].filter(activity => activity['_id'] !== payload), 
          activitiesGrouped: state['singlePageData']['activitiesGrouped'].map(group => ({ ...group, activities: group['activities'].filter(activity => activity['_id'] !== payload) })) },
      }

    case 'COMPLETE_ACTIVITY':
      return {
        ...state,
        singlePageData: { 
          ...state['singlePageData'], 
          activities: state['singlePageData']['activities'].map(activity => activity['_id'] === payload['id'] ? { ...activity, status: activity['status'] == 'completed' ? 'pending' : 'completed' } : activity),
          activitiesGrouped: state['singlePageData']['activitiesGrouped'].map(group => ({ ...group, activities: group['activities'].map(activity => activity['_id'] === payload['id'] ? { ...activity, status: activity['status'] == 'completed' ? 'pending' : 'completed' } : activity) })) 
        },
      }

    case 'SET_LOADING':
      return {
        ...state,
        isLoading: payload,
      }

    case 'UPDATE_SINGLE_PAGE_FIELD':
      return {
        ...state,
        singlePageData: {
          ...state.singlePageData,
          ...payload
        }
      }

    default:
      return state
  }
}

export default SinglePageReducer